var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "simple-form flex col-2" }, [
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.staffInfo.name || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.staffInfo.no || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.staffInfo.phoneNo || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.staffInfo.contactTel || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.staffInfo.contactEmail || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.staffInfo.memo || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(6),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _vm.staffInfo.headUuid != null
          ? _c("ul", { staticClass: "file-area clearfix" }, [
              _c(
                "li",
                { staticClass: "file-item show-usage image deletable" },
                [
                  _c("div", { staticClass: "file-content" }, [
                    _c("img", { attrs: { src: _vm.staffInfo.fileBrowseUrl } })
                  ])
                ]
              )
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm._m(7),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(8),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.staffInfo.disabled ? "已禁用" : "已启用"))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(9),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.staffInfo.disabledCause || ""))])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("姓名")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("员工编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("用户手机")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系邮箱")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("员工头像")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group center" }, [
      _c("div", { staticClass: "form-label" }, [_c("label")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [_c("span")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已禁用")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("禁用描述")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c24d91ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c24d91ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/ServicerXStaffDetail.vue
// module id = 1935
// module chunks = 1